import React from 'react';
import { ISelectOption } from '../../../domain/saved-filters/interface';
import { BaseFilterCheckboxSelect } from '../base/BaseFilterCheckboxSelect';

interface IProgramFilterSelectProps {
    value: (number | string)[] | undefined;
    onChange: (value: (number | string)[]) => void;
    options: ISelectOption<number | string>[];
    label?: string;
    disabled?: boolean;
    isLoading?: boolean;
}

export const ProgramFilterSelect: React.FC<IProgramFilterSelectProps> = ({ disabled = false, value = [], onChange, label, options, isLoading }) => {
    return (
        <BaseFilterCheckboxSelect
            resizable
            searchable
            multiple
            showSelectAllOption={false}
            selectedCountInLabel
            showClear
            options={options}
            value={value}
            onChange={onChange}
            label={label}
            disabled={disabled}
            loading={isLoading}
            height={300}
        />
    );
};
